<template>
  <div class="d-flex flex-column gap-12 mb-6" id="pdf">
    <!--PRINT HEADER-->
    <div
      class="d-flex flex-column align-center to-show"
      style="gap: 14px; display: none; visibility: hidden; height: 0px"
    >
      <div class="d-flex align-center">
        <v-img
          :src="require('@/assets/Logo2.png')"
          width="146"
          height="48"
          aspect-ratio="1"
        ></v-img>
      </div>

      <div class="d-flex align-center">
        <div class="page-title">แบบฟอร์มข้อเสนอโครงการ</div>
      </div>
      <div class="d-flex align-center">
        <div class="txt-head">
          โดยอุทยานวิทยาศาสตร์ {{ user.university_name ?? "" }}
        </div>
      </div>
    </div>

  
    <!--  PART ONE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-24">
            <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partOneValidate('one')"
            ></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                แผนงาน
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
              <div>{{ masterData.plan_master?.plan_name_th }}</div>
            </div>
          </div>

          <div v-if="plan_code === 'IRTC' || plan_code === 'CR' || plan_code === 'SP'">
            <!-- Form 1 #line2 -->
            <div class="d-flex gap-24">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partOneValidate('two')"
              ></ValidatorIcon>

              <div class="d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ชื่อโครงการ
                  <div>(ภาษาไทย)</div>
                  <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
                </div>
                <div>{{ partOneForm.project_name_th }}</div>
              </div>
            </div>

            <!-- Form 1 #line3 -->
            <div v-if="plan_code !== 'SP'" class="d-flex gap-24">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partOneValidate('three')"
              ></ValidatorIcon>

              <div class="d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ชื่อโครงการ
                  <div>(ภาษาอังกฤษ)</div>
                  <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
                </div>
                <div>{{ partOneForm.project_name_en }}</div>
              </div>
            </div>
          </div>

<!--          <div v-if="plan_code === 'SP'">-->
<!--            <div class="d-flex gap-24">-->
<!--              <ValidatorIcon-->
<!--                v-if="!$route.query.preview && dataReady"-->
<!--                :is-correct="partOneValidate('lab')"-->
<!--              ></ValidatorIcon>-->

<!--              <div class="d-flex gap-16">-->
<!--                <div class="mb-1 black&#45;&#45;text topic-field">-->
<!--                  ชื่อห้องปฏิบัติการ-->
<!--                </div>-->
<!--                <div>{{ partOneForm.lab_name }}</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div v-if="plan_code === 'STI'">
            <div class="d-flex gap-24">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partOneForm.activity ? true : false"
              ></ValidatorIcon>

              <div class="d-flex gap-16">
                <div class="mb-1 black--text topic-field">กิจกรรม</div>
                <div>
                  {{ masterData.activity_sti[partOneForm.activity - 1]?.name }}
                </div>
              </div>
            </div>
            <div class="d-flex gap-24">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partOneForm.project_name_th ? true : false"
              ></ValidatorIcon>

              <div class="d-flex gap-16">
                <div class="mb-1 black--text topic-field">
                  ชื่อโครงการ (ภาษาไทย)
                </div>
                <div>{{ partOneForm.project_name_th }}</div>
              </div>
            </div>
          </div>

          <!-- Form 1 #line4 -->
          <div class="d-flex gap-24" v-if="plan_code !== 'STI'">
            <!--            <ValidatorIcon-->
            <!--                v-if="!$route.query.preview && dataReady"-->
            <!--                :is-correct="partOneValidate('four')"-->
            <!--            ></ValidatorIcon>-->

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                อ้างอิง
                <div>(Requirement Form)</div>
              </div>
              <span>{{ partOneForm?.requirement_form?.doc_no || "-" }}</span>
            </div>
          </div>

          <!-- Form 1 #line5 -->
          <div class="d-flex gap-24" v-if="masterData.plan_master?.plan_code === 'SP' || (masterData.plan_master?.plan_code === 'CR' && (this.isFinal))">
            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                หน่วยงานที่รับผิดชอบ อุทยานวิทยาศาตร์ภาค
              </div>
              <span>{{ partOneForm.science_park }}</span>
            </div>
          </div>

          <!-- Form 1 #line6 -->
          <div class="d-flex gap-24" v-if="masterData.plan_master?.plan_code === 'CR' && (this.isFinal)">
            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                งบประมาณทั้งโครงการ
              </div>
              <span>{{ masterData.form_c?.budget_amount }}</span>
            </div>
          </div>

          <!-- Form 1 #line7 -->
          <div class="d-flex gap-24" v-if="masterData.plan_master?.plan_code === 'CR' && (this.isFinal) ">
            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">
                ระยะเวลาการดำเนินงาน (เดือน)
              </div>
              <span>{{ partOneForm.operation_period }}</span>
            </div>
          </div>

        </div>
      </div>

      <!-- รายชื่อผู้ประกอบการที่เข้ารับการบริการห้องปฏิบัติการ -->
      <div class="card-part" v-if="plan_code === 'SP'">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partOneValidate('SP')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              รายชื่อผู้ประกอบการที่เข้ารับการบริการห้องปฏิบัติการ
            </div>
          </div>

          <!-- header table -->
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th
                    width="10%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  ประเภทผู้ประกอบการ
                </th>
                <th
                    width="5%"
                    class="font-14 font-w-400 text-center"
                    style="border-bottom: 0px"
                >
                  ลำดับ
                </th>
                <th
                    width="23%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  ชื่อผู้ประกอบการและชื่อนิติบุคคล
                </th>
                <th
                    width="15%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  รายละเอียดห้องปฎิบัติการ
                </th>
                <th
                    width="10%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  เครื่องมือที่ใช้
                </th>
                <th
                    width="10%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  ผลิตภัณฑ์ที่มาใช้บริการ
                </th>
                <th
                    width="10%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  รหัสห้องปฎิบัติการNSTIS(Lab ID)
                </th>
                <th
                    width="7%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  จำนวนครั้ง
                </th>
              </tr>
              </thead>
            </template>
          </v-simple-table>

          <!-- body table -->
          <div>
            <v-card
                v-for="(company_contact, company_contacts_index) in company_contacts"
                :key="company_contacts_index"
                class="mb-4"
                style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a"
            >
              <v-simple-table >
                <template v-slot:default>
                  <tbody>
                  <tr v-if="company_contact.items.length == 0">
                    <td width="10%" style="border-bottom: 0px">
                      <v-layout align-center>
                        <v-flex>{{ company_contact.type }}</v-flex>
                      </v-layout>
                    </td>
                    <td
                        colspan="8"
                        class="text-center"
                        style="border-bottom: 0px; color: #b1b1b1"
                    >
                      <div class="text-center py-4">ไม่มีข้อมูล</div>
                    </td>
                  </tr>
                  <tr
                      v-else
                      v-for="(item, index) in company_contact.items"
                      :key="index"
                  >
                    <td width="10%" style="border-bottom: 0px">
                      <v-layout align-center v-if="index == 0">
                        <v-flex>{{ company_contact.type }}</v-flex>
                      </v-layout>
                    </td>
                    <td width="5%" class="text-center" style="border-bottom: 0px">
                      {{ index + 1 }}
                    </td>
                    <td width="23%" style="border-bottom: 0px">
                      {{ item.op_name }}/{{ item.juristic_name }}
                    </td>
                    <td width="15%" style="border-bottom: 0px">
                      {{ item.lab_detail }}
                    </td>
                    <td width="10%" style="border-bottom: 0px">
                      {{ item.instrument }}
                    </td>
                    <td width="10%" style="border-bottom: 0px">
                      {{ item.product_used }}
                    </td>
                    <td width="10%" style="border-bottom: 0px">
                      {{ item.lab_id }}
                    </td>
                    <td width="7%" class="text-center" style="border-bottom: 0px">
                      {{ item.count }}
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </div>

        </div>
      </div>
    </divcard>

    <!--  PART TWO  -->
    <CFormSummary_IRTC
      v-if="plan_code === 'IRTC'"
      :data="partTwoForm"
      :budget-list="partThreeBudgetList"
    ></CFormSummary_IRTC>
    <CFormSummary_SP
      v-if="plan_code === 'SP'"
      :data="partTwoForm"
    ></CFormSummary_SP>
    <CFormSummary_CR
      v-if="plan_code === 'CR'"
      :data="partTwoForm"
      :budget-list="partThreeBudgetList"
    ></CFormSummary_CR>
    <CFormSummary_STI
      v-if="plan_code === 'STI'"
      :data="partTwoForm"
    ></CFormSummary_STI>

    <!--  PART THREE  -->
    <divcard titled>
      <div class="card-part pt-0 s3-p1-h">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partThreeValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              1.แผนการดำเนินงาน (จัดทำในรูปเเบบ Project based management)
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll s3-p1">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div
                class="flex text-center"
                style="min-width: 43px; max-width: 43px"
              >
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div
              v-if="partThreeAllPlans && partThreeAllPlans.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in partThreeAllPlans"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8 no-box-shadow"
              >
                <div
                  class="flex two-line"
                  style="min-width: 120px; max-width: 120px; max-height: 45px"
                >
                  <tooltip-text :text="item.p1_activity_name" />
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field tf-active"
                    style="min-width: 40px; max-width: 40px; height: 100%"
                  >
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{ item.project_section_plan_month[ind].month_value ? item.project_section_plan_month[ind].month_value : "-" }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{ item.project_section_plan_month[ind].actual_month_value ? item.project_section_plan_month[ind].actual_month_value : "-" }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                          parseFloat(
                            item.project_section_plan_month[currIndex]
                              ?.month_value
                          ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card no-box-shadow">
                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field"
                      :class="{
                        'theme-color-four tf-error': totalWF() !== '1.00',
                      }"
                      style="min-width: 40px; max-width: 40px"
                    >
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(currIndex) }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(shortMonths.length - 1) }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? weightPlan(ind, "actual_month_value") : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? weightPlan(currIndex, "actual_month_value")
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              weightPlan(currIndex, "actual_month_value") * 100
                            ) / parseFloat(weightPlan(currIndex)),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>
         
                <div class="d-flex justify-space-between gap-8">
                  
                  <div class="d-flex items-center" style="min-width: 120px; max-width: 120px">
                      <ValidatorIcon
                      v-if="!$route.query.preview && dataReady"
                      :is-correct="validatePlanBudget()"
                    ></ValidatorIcon>
                    <div style="margin-left: 6px;">
                      แผนการใช้จ่ายจริง
                    </div>
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[ind]?.plan_budget_rate
                        ? partThreeBudgetPlans[ind]?.plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[currIndex]?.plan_budget_rate
                        ? partThreeBudgetPlans[currIndex].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      partThreeBudgetPlans[shortMonths.length - 1]
                        ?.plan_budget_rate
                        ? partThreeBudgetPlans[shortMonths.length - 1]
                            ?.plan_budget_rate
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && partThreeBudgetPlans[ind]?.use_budget_rate
                        ? formatNumber(
                            partThreeBudgetPlans[ind].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal &&
                      partThreeBudgetPlans[currIndex]?.use_budget_rate
                        ? formatNumber(
                            partThreeBudgetPlans[currIndex].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              partThreeBudgetPlans[currIndex]?.use_budget_rate *
                                100
                            ) /
                              parseFloat(
                                partThreeBudgetPlans[currIndex]
                                  ?.plan_budget_rate
                              ),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>

      <!--Form 2 budget-->
      <div class="card-part">
        <div class="mb-5">
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partThreeValidate('two')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              2. งบประมาณ (รายละเอียดการประเมินค่าใช้จ่ายในโครงการ)
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
          </div>

          <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
            <div style="width: 10%">รายการ</div>
            <div style="width: 25%">รายละเอียด</div>
            <div class="text-end" style="width: 10%">In-kind</div>
            <div class="text-end" style="width: 10%">In-cash</div>
            <div class="text-end" style="width: 19%">อุทยานวิทยาศาสตร์</div>
            <div class="text-end" style="width: 18%">รวม</div>
          </div>

          <div class="d-flex flex-column gap-16">
            <div
              v-for="(item, i) in partThreeBudgetList"
              :key="i"
              class="budget-item no-box-shadow"
            >
              <div class="d-flex black--text gap-12">
                <div style="width: 10%">{{ item.budget_name }}</div>
                <div
                  style="width: 25%"
                  v-html="item.budget_detail?.replace(/\n/g, '<br>')"
                ></div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_kind, 2) }}
                </div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_cash, 2) }}
                </div>
                <div class="text-end" style="width: 19%">
                  {{ formatNumber(item.budget_sci_park, 2) }}
                </div>
                <div class="text-end" style="width: 18%">
                  {{ formatNumber(item.budget_sum, 2) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="partThreeBudgetList && partThreeBudgetList.length > 0"
          class="d-flex flex-column gap-12 px-12 mb-5"
        >
          <div class="d-flex justify-space-between">
            <div class="black--text">
              รวมลำดับที่ 1-{{ partThreeBudgetList.length }}
            </div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  partThreeBudgetList
                    .map((x) => parseFloat(x.budget_sum))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมงบสนับสนุนโดยภาคเอกชน เป็นเงิน</div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  partThreeBudgetList
                    .map(
                      (x) =>
                        parseFloat(x.budget_in_kind) +
                        parseFloat(x.budget_in_cash)
                    )
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">
              รวมงบสนับสนุนโดยอุทยานวิทยาศาสตร์ เป็นเงิน
            </div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  partThreeBudgetList
                    .map((x) => parseFloat(x.budget_sci_park))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมค่าใช้จ่ายสุทธิ</div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  partThreeBudgetList
                    .map((x) => parseFloat(x.budget_sum))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
        </div>
      </div>

      <!--Form 3 plan-->
      <div v-if="plan_code === 'IRTC'">
        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partThreeValidate('three')"
              ></ValidatorIcon>
              <div class="font-type-bold black--text">
                3. ตารางสรุปแผนการดําเนินงาน
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
            </div>

            <!--   HEADERS   -->
            <div class="d-flex px-13 mb-5">
              <div class="flex" style="min-width: 100px; max-width: 230px">
                กิจกรรม
              </div>

              <div
                class="flex mx-3"
                style="min-width: 1px; max-width: 1px"
              ></div>

              <div class="d-flex justify-space-between" style="width: 100%">
                <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex"
                  style="min-width: 45px"
                >
                  <div class="text-center">{{ m.month }}</div>
                  <!--              <div class="text-center">65</div>-->
                </div>
              </div>
            </div>

            <!--   ITEMS   -->
            <div class="d-flex flex-column gap-16">
              <div
                v-for="(item, i) in partThreeAllProgressPlan"
                :key="i"
                class="summary-plan no-box-shadow"
              >
                <div class="d-flex black--text">
                  <div
                    class="mr-2"
                    style="min-width: 30px; max-width: 30px"
                  ></div>

                  <div
                    class="two-line"
                    style="min-width: 100px; max-width: 230px"
                  >
                    {{ item.activity_name }}
                  </div>

                  <v-divider
                    class="mx-3"
                    vertical
                    style="height: 54px"
                  ></v-divider>

                  <div class="flex plan-slot d-flex pr-10">
                    <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex"
                      :class="{
                        'progress-plan-mark': item.plan.includes(m.key),
                        'start-point':
                          Math.min.apply(null, item.plan) === m.key,
                        'end-point': Math.max.apply(null, item.plan) === m.key,
                      }"
                    >
                      <v-divider v-if="item.plan.includes(m.key)"></v-divider>
                      <div class="white--text arrow-right">&gt;</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- รายละเอียดการส่งมอบงาน IRTC-->
        <div v-if="!isFinal" class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partThreeValidate('four')"
              ></ValidatorIcon>
              <div class="font-type-bold black--text">
                4. รายละเอียดการส่งมอบงาน
              </div>
            </div>

              <div class="d-flex gap-12 theme-color-eight px-3 mb-3">
                  <div class="flex xs2">
                    งวดที่
                  </div>
                  <div class="flex xs2">
                    ภายใน (วัน)
                  </div>
                  <div class="flex xs2">
                    ร้อยละการเบิกจ่าย (%)
                  </div>
                  <div class="flex xs6">
                    รายละเอียดงานที่ต้องส่งมอบ
                  </div>
                </div>

              <!-- body table -->
              <div v-if="job_delivery_details.length > 0">
                <div
                  v-for="(
                    job_delivery_detail, job_delivery_detail_index
                  ) in job_delivery_details"
                  :key="job_delivery_detail_index"
                  class="mb-4 d-flex gap-12 budget-item no-box-shadow"
                  style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a"
                >

                <div class="flex xs2">
                    {{ job_delivery_detail.installment }}
                  </div>
                  <div class="flex xs2">
                    {{ job_delivery_detail.installment_date }}
                  </div>
                  <div class="flex xs2">
                    {{ job_delivery_detail.installment_percent }}
                  </div>
                  <div class="flex xs6">
                    {{ job_delivery_detail.installment_detail }}
                  </div>

                </div>
              </div>

              <div v-else class="no-plan-item">ไม่มีข้อมูล</div>

          </div>
        </div>

        <div v-if="isFinal" class="card-part pt-0">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoForm?.s3_problem ? true : false"
              ></ValidatorIcon>

              <div class="black--text txt-head">
                4. ปัญหาและอุปสรรคจากการดำเนินงาน
              </div>
              <!--              <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>-->
            </div>
            <div v-html="partTwoForm.s3_problem?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>

        <div v-if="isFinal" class="card-part pt-0">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoForm?.s3_solution ? true : false"
              ></ValidatorIcon>

              <div class="black--text txt-head">5. แนวทางในการแก้ไขปัญหา</div>
              <!--              <span class="theme-color-seven txt-normal" style="text-indent: 16px">(โปรดระบุ)</span>-->
            </div>
            <div v-html="partTwoForm.s3_solution?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>
      </div>
      <div v-if="plan_code === 'CR'">

        <!-- 3. การจัดการทรัพย์สินทางปัญญา -->
        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoForm?.s3_p3_ip_management ? true : false"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">
                3. การจัดการทรัพย์สินทางปัญญา
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div
                    v-html="
                      partTwoForm.s3_p3_ip_management?.replace(/\n/g, '<br>')
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 4. ปัญหาและอุปสรรคจากการดำเนินงาน -->
        <div class="card-part" v-if="isFinal">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                  v-if="!$route.query.preview && dataReady"
                  :is-correct="partTwoForm?.s3_p3_problem ? true : false"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">
                4. ปัญหาและอุปสรรคจากการดำเนินงาน CR
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div
                      v-html="
                      partTwoForm.s3_p3_problem?.replace(/\n/g, '<br>')
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 5. แนวทางในการแก้ไขปัญหา -->
        <div class="card-part" v-if="isFinal">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                  v-if="!$route.query.preview && dataReady"
                  :is-correct="partTwoForm?.s3_p3_solution ? true : false"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">
                5. แนวทางในการแก้ไขปัญหา
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div
                      v-html="
                      partTwoForm.s3_p3_solution?.replace(/\n/g, '<br>')
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
 
        <!-- 6. ความสนใจในการใช้บริการอื่นๆของอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต -->
        <div v-if="isFinal" class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoForm.s3_p3_interest"
              ></ValidatorIcon>
              <div class="font-type-bold black--text">
                6. ความสนใจในการใช้บริการอื่นๆของอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต
                <!--            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div
                    v-html="
                      partTwoForm.s3_p3_interest
                        ? partTwoForm.s3_p3_interest.join(', <br>')
                        : ''
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- รายละเอียดการส่งมอบงาน -->
        <div v class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partThreeValidate('four')"
              ></ValidatorIcon>
              <div class="font-type-bold black--text">
                {{ isFinal?'7':'4'}}. รายละเอียดการส่งมอบงาน
              </div>
            </div>

              <div class="d-flex gap-12 theme-color-eight px-3 mb-3">
                  <div class="flex xs2">
                    งวดที่
                  </div>
                  <div class="flex xs2">
                    ภายใน (วัน)
                  </div>
                  <div class="flex xs2">
                    ร้อยละการเบิกจ่าย (%)
                  </div>
                  <div class="flex xs6">
                    รายละเอียดงานที่ต้องส่งมอบ
                  </div>
                </div>

              <!-- body table -->
              <div v-if="job_delivery_details.length > 0">
                <div
                  v-for="(
                    job_delivery_detail, job_delivery_detail_index
                  ) in job_delivery_details"
                  :key="job_delivery_detail_index"
                  class="mb-4 d-flex gap-12 budget-item no-box-shadow"
                  style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a"
                >

                <div class="flex xs2">
                    {{ job_delivery_detail.installment }}
                  </div>
                  <div class="flex xs2">
                    {{ job_delivery_detail.installment_date }}
                  </div>
                  <div class="flex xs2">
                    {{ job_delivery_detail.installment_percent }}
                  </div>
                  <div class="flex xs6">
                    {{ job_delivery_detail.installment_detail }}
                  </div>

                </div>
              </div>

              <div v-else class="no-plan-item">ไม่มีข้อมูล</div>

          </div>
        </div>
      </div>
    </divcard>

    <!--  PART FOUR  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span> ผลผลิต /
          ตัวชี้วัดความสำเร็จ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partFourValidate('one')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              1. ตัวชี้วัดความสำเร็จ
              <!--              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
            </div>
          </div>

          <div class="d-flex flex-column gap-16">
            <!--   ผลผลิต   -->
            <div v-for="(item, i) in masterData.kpi_masters" :key="i">
              <div class="mb-3 black--text txt-bigger">
                ตัวชี้วัดที่ {{ item.no }} {{ item.name }}
              </div>

              <OOILineField
                v-for="(sub, ind) in item.kpi_sub_masters"
                :key="ind"
                :summary="true"
                :label="sub.name"
                :unit="sub.unit"
                :readonly="sub.name === 'รวม'"
                :field="kpi[sub.id] ? kpi[sub.id].kpi_sub_value : ''"
              ></OOILineField>
            </div>
          </div>
        </div>
      </div>

      <!------------------------------------- IRTC -------------------------------------------------->
      <div v-if="plan_code === 'IRTC'">
        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partFourValidate('three')"
              ></ValidatorIcon>
              <div class="font-type-bold black--text">
                ผลลัพธ์
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
            </div>

            <div class="d-flex gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">เชิงปริมาณ</div>
                <div
                  v-html="partTwoForm.s4_p3_quantity?.replace(/\n/g, '<br>')"
                ></div>
              </div>

              <div class="flex xs6">
                <div class="mb-1 black--text">เชิงคุณภาพ</div>
                <div
                  v-html="partTwoForm.s4_p3_quality?.replace(/\n/g, '<br>')"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partFourValidate('four')"
              ></ValidatorIcon>
              <div class="font-type-bold black--text">
                ประโยชน์ที่ได้รับ
                <!--                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
              </div>
            </div>

            <div class="d-flex gap-16">
              <div class="flex xs6">
                <div class="mb-1 black--text">เชิงปริมาณ</div>
                <div
                  v-html="partTwoForm.s4_p4_quantity?.replace(/\n/g, '<br>')"
                ></div>
              </div>

              <div class="flex xs6">
                <div class="mb-1 black--text">เชิงคุณภาพ</div>
                <div
                  v-html="partTwoForm.s4_p4_quality?.replace(/\n/g, '<br>')"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
              v-if="!$route.query.preview && dataReady"
              :is-correct="partFourValidate('five')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              การประเมินผลกระทบด้านเศรษฐกิจ
            </div>
          </div>

          <div>
            <div class="d-flex gap-16 mb-5">
              <div
                style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"
              ></div>
              <div class="flex xs3 txt-bigger text-center">
                ประมาณมูลค่า (บาท)
              </div>
              <div class="flex txt-bigger text-center">
                คาดการณ์ผลกระทบที่เกิดขึ้น
              </div>
            </div>
            <ul>
              <li>
                <div class="d-flex gap-16">
                  <div style="min-width: 30%; max-width: 30%">
                    ยอดขายรายได้เฉลี่ย/การเพิ่มขึ้นยอดขายของผลิตภัณฑ์ กำไร (บาท)
                  </div>
                  <div class="flex xs3">
                    <div>{{ partTwoForm.s4_p4_revenue }}</div>
                  </div>
                  <div class="flex">
                    <div>{{ partTwoForm.s4_p4_revenue_desc }}</div>
                  </div>
                </div>
              </li>
              <li class="mb-2">
                <div class="d-flex gap-16">
                  <div style="min-width: 30%; max-width: 30%">
                    ต้นทุนการบริการบริหารจัดการ ทรัพยากรในองค์กรค่าใช้จ่ายการ
                    ผลิต ค่าใช้จ่ายอื่นๆ การจ้างงาน(คน) มูลค่าการจ้างงาน(บาท)
                    การลดค่า ใช้จ่าย ลดต้นทุนในการผลิต
                  </div>
                  <div class="flex xs3">
                    <div>{{ partTwoForm.s4_p4_mgm_cost }}</div>
                  </div>
                  <div class="flex">
                    <div>{{ partTwoForm.s4_p4_mgm_cost_desc }}</div>
                  </div>
                </div>
              </li>
              <li class="mb-2">
                <div class="d-flex gap-16">
                  <div style="min-width: 30%; max-width: 30%">
                    ประสิทธิภาพ/กำลังการผลิต การ เพิ่มกำลังการผลิต(บาท)
                    มูลค่าของ การเพิ่มประสิทธิภาพหรือคุณภาพ ของผลิตภัณฑ์(บาท)
                  </div>
                  <div class="flex xs3">
                    <div>{{ partTwoForm.s4_p4_prod_cap }}</div>
                  </div>
                  <div class="flex">
                    <div>{{ partTwoForm.s4_p4_prod_cap_desc }}</div>
                  </div>
                </div>
              </li>
              <li>
                <div class="d-flex gap-16">
                  <div style="min-width: 30%; max-width: 30%">
                    การลงทุน มูลค่าการลงทุน R&D (บาท) จำนวนผลิตภัณฑ์ใหม่ที่เสนอ
                    ขายในตลาดต่อปี
                  </div>
                  <div class="flex xs3">
                    <div>{{ partTwoForm.s4_p4_investment }}</div>
                  </div>
                  <div class="flex">
                    <div>{{ partTwoForm.s4_p4_investment_desc }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="card-part">
          <div class="d-flex gap-16 mb-5">
            <div
              style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"
            ></div>
            <div class="flex xs3 txt-bigger text-center">
              ประมาณมูลค่า (บาท)
            </div>
            <div class="flex txt-bigger text-center">
              คาดการณ์ผลกระทบที่เกิดขึ้น
            </div>
          </div>
          <div class="d-flex gap-16">
            <div
              style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)"
            >
              การประเมินผลกระทบด้านสังคม (จ้างคนในพื้นที่, วัตถุดิบท้องถิ่น)
            </div>
            <div class="flex xs3">
              <div>{{ partTwoForm.s4_p4_social_impact_eval }}</div>
            </div>
            <div class="flex">
              <div>{{ partTwoForm.s4_p4_social_impact_eval_desc }}</div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div class="d-flex gap-16 mb-5">
            <div
              style="min-width: calc(24px + 30%); max-width: calc(24px + 30%)"
            ></div>
            <div class="flex xs3 txt-bigger text-center">
              ประมาณมูลค่า (บาท)
            </div>
            <div class="flex txt-bigger text-center">
              คาดการณ์ผลกระทบที่เกิดขึ้น
            </div>
          </div>
          <div class="d-flex gap-16">
            <div
              style="min-width: calc(18px + 30%); max-width: calc(18px + 30%)"
            >
              การประเมินผลกระทบด้าน วิทยาศาสตร์และเทคโนโลยี (มีเครื่องจักร,
              ลิขสิทธิ์, งานวิจัย ต่อยอด)
            </div>
            <div class="flex xs3">
              <div>{{ partTwoForm.s4_p4_sci_tech_impact_eval }}</div>
            </div>
            <div class="flex">
              <div>{{ partTwoForm.s4_p4_sci_tech_impact_eval_desc }}</div>
            </div>
          </div>
        </div>

        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partFourValidate('six')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">
                หากไม่ได้เข้ารับบริการกับทางอุทยานวิทยาศาสตร์ภูมิภาค
                จะเกิดผลกระทบ/ผลเสียหายอย่างไร ท่านจะไปใช้บริการกับหน่วยงานใด
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <div class="d-flex gap-16">
                <div class="flex xs6 d-flex gap-16">
                  <div
                    v-html="partTwoForm.s4_p5_opinion?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!------------------------------------- SP -------------------------------------------------->
      <div v-if="plan_code === 'SP'">
        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoValidate('SP_s4_p2')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">ผลลัพธ์</div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 5 #line1 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงปริมาณ</div>
                  <div
                    class="pl-10"
                    v-html="partTwoForm.result_quantity?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
              <!-- Form 5 #line2 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงคุณภาพ</div>
                  <div
                    class="pl-10"
                    v-html="partTwoForm.result_quality?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                  v-if="!$route.query.preview && dataReady"
                  :is-correct="partTwoValidate('SP_s4_p3')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">ผลผลิตและตัวชี้วัด</div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 5 #line1 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">ในเชิงเศรษฐกิจ</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.kpi_eco?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
              <!-- Form 5 #line2 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">ในเชิงสังคม</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.kpi_social?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                  v-if="!$route.query.preview && dataReady"
                  :is-correct="partTwoValidate('SP_s4_p4')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">ผลกระทบ</div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 5 #line1 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงปริมาณ/เชิงเศรษฐกิจของภูมิภาค</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.impact_quantity?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
              <!-- Form 5 #line2 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงคุณภาพ/เชิงสังคม</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.impact_quality?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--ภาคผนวก -->
        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
<!--              <ValidatorIcon-->
<!--                  v-if="!$route.query.preview && dataReady"-->
<!--                  :is-correct="partFiveAttachment.find((f) => f.doc_type === 'annex')"-->
<!--              ></ValidatorIcon>-->

              <div class="font-type-bold black--text">ภาคผนวก</div>
            </div>


            <div>
              <v-layout
                  align-center
                  class="mt-3"
                  v-for="(file, f) in partFiveAttachment.filter((f) => f.doc_type === 'annex')"
                  :key="f"
              >
                <v-flex shrink class="to-hide">
                  <v-btn
                      depressed
                      dark
                      rounded
                      width="125"
                      color="#F15A29"
                      @click="downloadFile(file)"
                  >
                    <Iconify
                        style="color: #fff"
                        icon="system-uicons:download"
                    ></Iconify>
                    <span class="font-12 font-w-700">ดาวน์โหลด</span>
                  </v-btn>
                </v-flex>
                <v-flex shrink ml-3>
                  {{ file.file_name }}
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>

      <!------------------------------------- CR -------------------------------------------------->
      <div v-if="plan_code === 'CR'">
        <div class="card-part">
          <!-- Form 4 -->
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoValidate('CR_s4_p2')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">2. ผลผลิตและตัวชี้วัดความสำเร็จ</div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 5 #line1 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">ในเชิงเศรษฐกิจ</div>
                  <div
                    class="pl-10"
                    v-html="partTwoForm.s4_p2_eco?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
              <!-- Form 5 #line2 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">ในเชิงสังคม </div>
                  <div
                    class="pl-10"
                    v-html="partTwoForm.s4_p2_social?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoForm.s4_p3_result ?? false"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">3. ผลลัพธ์ที่ได้จากโครงการ</div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 5 #line1 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div
                    class="pl-10"
                    v-html="partTwoForm.s4_p3_result?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partTwoValidate('CR_s4_p4')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">
                4. ผลกระทบ
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 5 #line1 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงคุณภาพ/เชิงสังคม</div>
                  <div
                    class="pl-10"
                    v-html="partTwoForm.s4_p4_quality?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
              <!-- Form 5 #line2 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงปริมาณ/เชิงเศรษฐกิจของภูมิภาค</div>
                  <div
                    class="pl-10"
                    v-html="partTwoForm.s4_p4_quantity?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                  v-if="!$route.query.preview && dataReady"
                  :is-correct="partTwoValidate('CR_s4_p5')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">
                5. ประโยชน์ที่ได้รับ
              </div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <!-- Form 5 #line1 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงคุณภาพ</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.s4_p5_quality?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
              <!-- Form 5 #line2 -->
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงปริมาณ</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.s4_p5_quantity?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!------------------------------------- STI -------------------------------------------------->
      <div v-if="plan_code === 'STI'">
        <!-- 2. ผลลัพธ์ที่ได้จากโครงการ (Outcome) -->
        <div class="card-part">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
              <ValidatorIcon
                  v-if="!$route.query.preview && dataReady"
                  :is-correct="partTwoValidate('STI_s4_p2')"
              ></ValidatorIcon>

              <div class="font-type-bold black--text">2. ผลลัพธ์ที่ได้จากโครงการ (Outcome)</div>
            </div>

            <div class="indent-info d-flex flex-column gap-8">
              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงปริมาณ</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.result_quantity?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>

              <div class="flex-center gap-16">
                <div class="flex">
                  <div class="mb-1 black--text">เชิงคุณภาพ</div>
                  <div
                      class="pl-10"
                      v-html="partTwoForm.result_quality?.replace(/\n/g, '<br>')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 3. จำนวนผู้ประกอบการที่สำเร็จการบ่มเพาะ (P/F Only)-->
        <div class="card-part" v-if="masterData.form_c.project_section_general_info.activity === '1'  && isFinal">
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partFourValidate('completed_incubation_companies')"
            ></ValidatorIcon>
            <div class="font-type-bold black--text">
              3.จำนวนผู้ประกอบการที่สำเร็จการบ่มเพาะ
            </div>
          </div>
          <div class="card-part mt-5 pt-0">
            <div>
              <v-layout class="mt-3" v-for="(company, f) in companyList" :key="f">
                <v-flex xs3 class="mr-8">
                  <div class="mb-1 black--text">ปีผู้ประกอบการที่เข้าร่วมบ่มเพาะ (พ.ศ.)</div>
                  {{ company.participants_year }}
                </v-flex>
                <v-flex xs3>
                  <div class="mb-1 black--text">จำนวน (ราย)</div>
                  {{ company.participants_count }}
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
        <!-- 3.S/I 4.P/F ตารางสรุปผู้ประกอบการที่อยู่ระหว่างกระบวนบ่มเพาะธุรกิจ วทน. (ตั้งแต่ปีเก่า - ปีปัจจุบัน) -->
        <div class="card-part" v-if="masterData.form_c.project_section_general_info.activity === '1'" >
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon
                v-if="!$route.query.preview && dataReady"
                :is-correct="partFourValidate('incubation_companies')"
            ></ValidatorIcon>

            <div class="font-type-bold black--text">
              {{ isFinal ? '4.' : '3.' }}ตารางสรุปผู้ประกอบการที่อยู่ระหว่างกระบวนบ่มเพาะธุรกิจ วทน.
              <span class="font-14 font-w-400">(ตั้งแต่ปีเก่า - ปีปัจจุบัน)</span>
            </div>
          </div>

          <!-- header table -->
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th
                    width="10%"
                    class="font-14 font-w-400 text-center"
                    style="border-bottom: 0px"
                >
                  ปีงบประมาณ
                </th>
                <th
                    width="5%"
                    class="font-14 font-w-400 text-center"
                    style="border-bottom: 0px"
                >
                  ลำดับ
                </th>
                <th
                    width="15%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  ชื่อมหาวิทยาลัย
                </th>
                <th
                    width="15%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  ผลิตภัณฑ์
                </th>
                <th
                    width="15%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  เอกชน
                </th>
                <th
                    width="15%"
                    class="font-14 font-w-400"
                    style="border-bottom: 0px"
                >
                  ประเภทเทคโนโลยี
                </th>
                <th
                    width="10%"
                    class="font-14 font-w-400 text-center"
                    style="border-bottom: 0px"
                >
                  สถานะ
                </th>
              </tr>
              </thead>
            </template>
          </v-simple-table>

          <!-- body table -->
          <div v-if="incubation_companies.length > 0">
            <v-card
                v-for="(
            incubation_companie, incubation_companie_index
          ) in incubation_companies"
                :key="incubation_companie_index"
                class="mb-4"
                style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a"
            >
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                  <tr
                      v-for="(item, index) in incubation_companie[1]"
                      :key="index"
                  >
                    <td
                        width="10%"
                        class="text-center"
                        style="border-bottom: 0px"
                    >
                      <span v-if="index == 0">{{ incubation_companie[0] }}</span>
                    </td>
                    <td width="5%" class="text-center" style="border-bottom: 0px">
                      {{ index + 1 }}
                    </td>
                    <td width="15%" style="border-bottom: 0px">
                      {{ item.university_name }}
                    </td>
                    <td width="15%" style="border-bottom: 0px">
                      {{ item.product }}
                    </td>
                    <td width="15%" style="border-bottom: 0px">
                      {{ item.company }}
                    </td>
                    <td width="15%" style="border-bottom: 0px">
                      {{ item.technology_type === 'อุตสาหกรรมอื่น (ระบุ)' ? item.technology_type_other : item.technology_type }}
                    </td>
                    <td
                        width="10%"
                        class="text-center"
                        style="border-bottom: 0px"
                    >
                      {{ item.status }}
                    </td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <!-- {{ incubationCompanyMainIndex }} : {{ incubationCompanySubIndex }} -->
          </div>

          <div v-else>
            <v-card
                class="mb-4"
                style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a"
            >
              <div class="text-center py-4">ไม่มีข้อมูล</div>
            </v-card>
          </div>


        </div>
        <!-- (4.SI 5.PF ภาคผนวก && activity1) || (activity2 && 3.p/f )-->
        <div class="card-part"
             v-if="masterData.form_c.project_section_general_info.activity === '1' ||
             (masterData.form_c.project_section_general_info.activity === '2' && isFinal)">
          <div>
            <div class="d-flex align-center gap-24 mb-3">
<!--              <ValidatorIcon-->
<!--                  v-if="!$route.query.preview && dataReady"-->
<!--                  :is-correct="partFiveAttachment.find((f) => f.doc_type === 'annex')"-->
<!--              ></ValidatorIcon>-->
              <div class="font-type-bold black--text">
                {{ masterData.form_c.project_section_general_info.activity === '1' && !isFinal ? '4' : masterData.form_c.project_section_general_info.activity === '1' && isFinal ? '5' : '3' }}. ภาคผนวก
              </div>
            </div>


            <div>
              <v-layout
                  align-center
                  class="mt-3"
                  v-for="(file, f) in partFiveAttachment.filter((f) => f.doc_type === 'annex')"
                  :key="f"
              >
                <v-flex shrink class="to-hide">
                  <v-btn
                      depressed
                      dark
                      rounded
                      width="125"
                      color="#F15A29"
                      @click="downloadFile(file)"
                  >
                    <Iconify
                        style="color: #fff"
                        icon="system-uicons:download"
                    ></Iconify>
                    <span class="font-12 font-w-700">ดาวน์โหลด</span>
                  </v-btn>
                </v-flex>
                <v-flex shrink ml-3>
                  {{ file.file_name }}
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART FIVE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div><span class="theme-color-one">ส่วนที่ 5 :</span> เอกสารแนบ</div>
        </div>

        <!-- Form 5 -->
        <div>
          <v-layout
            align-center
            class="mt-3"
            v-for="(file, f) in partFiveAttachment.filter((f) => f.doc_type !== 'annex')"
            :key="f"
          >
            <v-flex shrink class="to-hide">
              <v-btn
                depressed
                dark
                rounded
                width="125"
                color="#F15A29"
                @click="downloadFile(file)"
              >
                <Iconify
                  style="color: #fff"
                  icon="system-uicons:download"
                ></Iconify>
                <span class="font-12 font-w-700">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              {{ file.file_name }}
            </v-flex>
          </v-layout>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import {
  eventBus,
  formatNumber,
  validateEmail,
} from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import OOILineField from "../../../components/OOILineField";
import ValidatorIcon from "../../../components/ValidatorIcon";
import CFormSummary_IRTC from "./CFormSummary/CFormSummary_IRTC";
import CFormSummary_SP from "./CFormSummary/CFormSummary_SP";
import CFormSummary_CR from "./CFormSummary/CFormSummary_CR";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import { apiDomain } from "@/store/constants";
import axios from "axios";
import CFormSummary_STI from "@/views/ProjectManagement/C/CFormSummary/CFormSummary_STI.vue";

export default {
  name: "CFormSummary",
  components: {
    CFormSummary_STI,
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon,
    CFormSummary_IRTC,
    CFormSummary_SP,
    CFormSummary_CR,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      private_sum: null,
      inkind_sum: null,
      incash_sum: null,
      scipark_sum: null,
      inkind_percent: null,
      incash_percent: null,
      scipark_percent: null,
      partOneForm: {},
      partTwoForm: {},
      shortMonths: [],
      partThreeForm: {},
      partThreeAllPlans: [],
      partThreeBudgetPlans: [],
      partThreeBudgetList: [],
      partThreeAllProgressPlan: [],
      kpi: {},
      partFiveAttachment: [],
      plan_code: "",
      ableToSubmit: true,
      currIndex: 0,
      company_contacts: [
        {
          type: "ในมหาวิทยาลัย",
          items: [],
        },
        {
          type: "นอกมหาวิทยาลัย",
          items: [],
        },
        {
          type: "ในโครงการอุทยานวิทยาศาสตร์",
          items: [],
        },
      ],
      companyList: [],
      incubation_companies: [],
      dataReady: false
    };
  },
  computed: {
    ...mapState({
      userRole: (state) => state.Auth.User.user_type,
      user: (state) => state.Auth.User,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
    activity() {
      return this.masterData.form_c.project_section_general_info.activity || null
    },
  },
  async created() {
    this.ableToSubmit = true;
    // PART ONE
    this.partOneForm = this.masterData.form_c.project_section_general_info;
    if (this.masterData?.form_c?.company_contacts) {
      this.masterData?.form_c?.company_contacts.forEach((company_contact) => {
        if (company_contact.op_type == "นอกมหาวิทยาลัย") {
          this.company_contacts[1].items.push(company_contact);
        } else if (company_contact.op_type == "ในมหาวิทยาลัย") {
          this.company_contacts[0].items.push(company_contact);
        } else if (company_contact.op_type == "ในโครงการอุทยานวิทยาศาสตร์") {
          this.company_contacts[2].items.push(company_contact);
        }
      });
    }
    // PART TWO
    this.partTwoForm = {
      ...this.masterData.form_c.project_section,
      project_teams: this.masterData.form_c.project_teams,
      project_head_team: this.masterData.form_c.project_head_team,
      project_manager_team: this.masterData.form_c.project_manager_team,
      project_coordinate_team: this.masterData.form_c.project_coordinate_team,
      activity: this.masterData.form_c.project_section_general_info.activity,
    };
    // PART THREE
    this.partThreeAllPlans =
      this.masterData.form_c.project_section_plan.project_plan_p1 || [];
    this.partThreeBudgetPlans =
      this.masterData.form_c.project_section_plan
        .project_section_plan_p1_budget || [];
    this.partThreeBudgetList =
      this.masterData.form_c.project_section_plan.project_section_budget || [];
    if (this.masterData.form_c) {
      this.form = this.masterData.form_c.project_section;
      for (const x of this.masterData.kpi_masters) {
        for (const y of x.kpi_sub_masters) {
          if (y.kpi_sub_values) {
            let subId = y.kpi_sub_values.kpi_sub_master_id.toString();
            this.kpi[subId] = {};
            this.kpi[subId].id = y.kpi_sub_values.id;
            this.kpi[subId].kpi_sub_master_id =
              y.kpi_sub_values.kpi_sub_master_id;
            this.kpi[subId].kpi_sub_value = y.kpi_sub_values.kpi_sub_value;
          }
        }
      }
    }
    // PART FOUR
    this.job_delivery_details =
      this.masterData.form_c?.job_delivery_details || [];
    this.companyList = this.masterData.form_c.completed_incubation_company || []
    this.incubation_companies = this.masterData.form_c.incubation_companies ? this.unflattenArray(this.masterData.form_c.incubation_companies) : []

    // PART FIVE
    this.partFiveAttachment = this.masterData.form_c.attachments || [];
    console.log('partFiveAttachment', this.partFiveAttachment)

    this.plan_code = this.masterData.plan_master.plan_code;

    this.fiscalYear = this.masterData.form_c.fiscal_year;
    this.calculateBudgetProportion();
    this.plotProgressPlanGraphData();
    this.setupBudgetYearMonth();
    this.currIndex = this.getCurrIndex();
    this.dataReady = true

    eventBus.$on("CFormPlanAbleToSubmit", (value) => {
      this.allowFormAbleSubmit(value);
    });
  },
  methods: {
    totalWF() {
      if (!this.partThreeAllPlans || this.partThreeAllPlans.length === 0)
        return "-";
      let total = this.partThreeAllPlans
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    unflattenArray(input) {
      const output = [];

      for (const obj of input) {
        const fiscalYear = obj.fiscal_year;
        let yearGroup = output.find((group) => group[0] === fiscalYear);

        if (!yearGroup) {
          yearGroup = [fiscalYear, []];
          output.push(yearGroup);
        }

        yearGroup[1].push(obj);
      }

      return output;
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.partThreeAllPlans) {
        let i = 0;
        for (const y of x.project_section_plan_month) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    calculateBudgetProportion() {
      let budgetList = this.partThreeBudgetList;

      if (budgetList !== undefined && budgetList.length > 0) {
        let all_sum = budgetList
          .map((x) => x.budget_sum)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_sum = budgetList
          .map((x) => x.budget_in_kind)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.incash_sum = budgetList
          .map((x) => x.budget_in_cash)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.private_sum = this.inkind_sum + this.incash_sum;
        this.scipark_sum = budgetList
          .map((x) => x.budget_sci_park)
          .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
        this.inkind_percent = ((this.inkind_sum * 100) / all_sum).toFixed(2);
        this.incash_percent = ((this.incash_sum * 100) / all_sum).toFixed(2);
        this.scipark_percent = ((this.scipark_sum * 100) / all_sum).toFixed(2);
      }
    },
    plotProgressPlanGraphData() {
      let allPG = [];
      if (this.partThreeAllPlans.length > 0) {
        this.partThreeAllPlans.forEach((plan) => {
          let PG = {
            activity_name: plan.p1_activity_name,
            plan: [],
          };
          if (
            plan.project_section_plan_month &&
            plan.project_section_plan_month.length > 0
          ) {
            let month_plans = [];
            let is_end = false;
            plan.project_section_plan_month.forEach((month, index) => {
              if (
                month.month_value !== null &&
                parseFloat(month.month_value) !== 100
              )
                month_plans.push(index + 1);
              else if (parseFloat(month.month_value) === 100.0 && !is_end) {
                month_plans.push(index + 1);
                is_end = true;
              }
            });
            PG.plan = month_plans;
          }
          allPG.push(PG);
        });
      }

      this.partThreeAllProgressPlan = allPG;
    },
    weightPlan(index, field = "month_value") {
      let total = [];
      for (const x of this.partThreeAllPlans) {
        let result = x.project_section_plan_month[index]
          ? parseFloat(x.project_section_plan_month[index][field] * x.p1_wf)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect && this.dataReady) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("cFormAbleToSubmit", this.ableToSubmit);
    },
    partOneValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (!this.masterData.plan_master?.plan_name_th) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (!this.partOneForm.project_name_th) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "three":
          if (!this.partOneForm.project_name_en) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "lab":
          if (!this.partOneForm.lab_name) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "SP":
          isCorrect = false;
          if(this.company_contacts.length > 0) {
            this.company_contacts.forEach((x) => {
              if (x.items.length > 0) {
                isCorrect = true
              }
            });
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        // case 'four':
        //   if (!this.partOneForm.requirement_form_id) {
        //     isCorrect = false
        //   }
        //   this.allowFormAbleSubmit(isCorrect)
        //   return isCorrect
      }
    },
    partTwoValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (
            !this.partTwoForm.s2_p1_name ||
            !this.partTwoForm.s2_p1_position ||
            !this.partTwoForm.s2_p1_dep ||
            !this.partTwoForm.s2_p1_org ||
            !this.partTwoForm.s2_p1_addr ||
            !this.partTwoForm.s2_p1_expertise ||
            !this.partTwoForm.s2_p1_resp
          ) {
            isCorrect = false;
          }

          if (!this.partTwoForm.s2_p1_phone) {
            isCorrect = false;
          }

          if (!validateEmail(this.partTwoForm.s2_p1_email)) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (
            !this.partTwoForm.s2_p2_pm_name ||
            !this.partTwoForm.s2_p2_pm_position ||
            !this.partTwoForm.s2_p2_pm_phone ||
            !this.partTwoForm.s2_p2_pm_email ||
            !this.partTwoForm.s2_p2_proj_coord_name ||
            !this.partTwoForm.s2_p2_proj_coord_position ||
            !this.partTwoForm.s2_p2_proj_coord_phone ||
            !this.partTwoForm.s2_p2_proj_coord_email
          ) {
            isCorrect = false;
          }

          if (
            !this.partTwoForm.s2_p2_pm_phone ||
            !this.partTwoForm.s2_p2_proj_coord_phone) {
            isCorrect = false;
          }

          if (
            !validateEmail(this.partTwoForm.s2_p2_pm_email) ||
            !validateEmail(this.partTwoForm.s2_p2_proj_coord_email)
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "three":
          if (
            !this.partTwoForm.s2_p3_prv_org_name ||
            !this.partTwoForm.s2_p3_prv_org_address ||
            !this.partTwoForm.s2_p3_prv_org_phone ||
            !this.partTwoForm.s2_p3_prv_org_email ||
            !this.partTwoForm.s2_p3_prv_org_type ||
            !this.partTwoForm.s2_p3_prv_org_trend
          ) {
            isCorrect = false;
          }

          if (!this.partTwoForm.s2_p3_prv_org_phone) {
            isCorrect = false;
          }

          if (!validateEmail(this.partTwoForm.s2_p3_prv_org_email)) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "four":
          if (!this.partTwoForm.s2_p4_prv_org_involved) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "five":
          if (
            !this.partTwoForm.s2_p5_prv_org_impr_product_quality ||
            !this.partTwoForm.s2_p5_prv_org_impr_process_issue ||
            !this.partTwoForm.s2_p5_prv_org_impr_process_eff ||
            !this.partTwoForm.s2_p5_prv_org_impr_new_product
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "six":
          if (!this.partTwoForm.s2_p6_prv_org_issue_desc) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "seven":
          if (!this.partTwoForm.s2_p7_inno_desc) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "eight":
          if (
            !this.partTwoForm.s2_p8_prv_org_project_readiness ||
            !this.partTwoForm.s2_p8_prv_org_rnd_readiness ||
            !this.partTwoForm.s2_p8_prv_org_financial_readiness ||
            !this.partTwoForm.s2_p8_prv_org_mgmt_readiness
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "nine":
          if (
            !this.partTwoForm.s2_p9_personnel_expertise ||
            !this.partTwoForm.s2_p9_lab_eqt_readiness ||
            !this.partTwoForm.s2_p9_knowledge_readiness
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "ten":
          if (!this.partTwoForm.s2_p10_project_scope_detail) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "eleven":
          if (!this.partTwoForm.s2_p11_principle) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "twelve":
          if (!this.partTwoForm.s2_p12_objective) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "SP_s4_p2":
          if (
            !this.partTwoForm ||
            !this.partTwoForm.result_quantity ||
            !this.partTwoForm.result_quality
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "SP_s4_p3":
          if (
            !this.partTwoForm ||
            !this.partTwoForm.kpi_eco ||
            !this.partTwoForm.kpi_social
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "SP_s4_p4":
          if (
            !this.partTwoForm ||
            !this.partTwoForm.impact_quantity ||
            !this.partTwoForm.impact_quality
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "CR_s4_p2":
          if (
            !this.partTwoForm ||
            !this.partTwoForm.s4_p2_eco ||
            !this.partTwoForm.s4_p2_social
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "CR_s4_p4":
          if (
            !this.partTwoForm ||
            !this.partTwoForm.s4_p4_quality ||
            !this.partTwoForm.s4_p4_quantity
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "CR_s4_p5":
          if (
              !this.partTwoForm ||
              !this.partTwoForm.s4_p5_quality ||
              !this.partTwoForm.s4_p5_quantity
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "STI_s4_p2":
          if (
            !this.partTwoForm ||
            !this.partTwoForm.result_quality ||
            !this.partTwoForm.result_quantity
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "STI_s4_p3":
          if ( !this.completed_incubation_company || !this.completed_incubation_company.length ) {
            isCorrect = false;
          }else{
            this.completed_incubation_company.forEach((element) => {
              if (
                !element.participants_year ||
                !element.participants_count
              ) {
                isCorrect = false;
              }
            });
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "STI_s4_p4":
          if ( !this.incubation_companies || this.incubation_companies.length < 1 ) {
            isCorrect = false;
          }else{
            this.incubation_companies.forEach((company) => {
              if (
                !company.fiscal_year ||
                !company.university_name ||
                !company.product ||
                !company.company ||
                !company.technology_type ||
                !company.status
              ) {
                isCorrect = false;
              }
            });
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

      }
    },
    partThreeValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (
            !this.partThreeAllPlans ||
            this.partThreeAllPlans.length < 1 ||
            this.totalWF() !== "1.00"
          ) {
            isCorrect = false;
          }
          // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
          if (
            this.partThreeBudgetPlans.filter((x) => x.plan_budget !== "")
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != 0)
              .length === 0 ||
            this.partThreeBudgetPlans.filter((x) => x.plan_budget != "0.00")
              .length === 0
          ) {
            isCorrect = false;
          }
          // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
          if (
            this.partThreeBudgetPlans
              .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
              .reduce((a, b) => a + b, 0) !==
            this.partThreeBudgetList
              .map((x) => parseFloat(x.budget_sum))
              .reduce((a, b) => a + b, 0)
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (
            !this.partThreeBudgetList ||
            this.partThreeBudgetList.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "three":
          if (
            !this.partThreeAllProgressPlan ||
            this.partThreeAllProgressPlan.length < 1
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "four":
          if (
            !this.job_delivery_details ||
            this.job_delivery_details.length < 1
          ) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    validatePlanBudget() {
      let isCorrect = true;
      // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
      if (
        this.partThreeBudgetPlans.filter((x) => x.plan_budget !== "")
          .length === 0 ||
        this.partThreeBudgetPlans.filter((x) => x.plan_budget != 0)
          .length === 0 ||
        this.partThreeBudgetPlans.filter((x) => x.plan_budget != "0.00")
          .length === 0
      ) {
        isCorrect = false;
      }
      // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
      if (
        this.partThreeBudgetPlans
          .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
          .reduce((a, b) => a + b, 0) !==
        this.partThreeBudgetList
          .map((x) => parseFloat(x.budget_sum))
          .reduce((a, b) => a + b, 0)
      ) {
        isCorrect = false;
      }
      return isCorrect;
    },
    partFourValidate(section) {
      let isCorrect = true;
      let annexFiles = [];
      switch (section) {
        case "one":
          //check if kpi_sub_value in each this.kpi is empty
          if (Object.values(this.kpi).length === 0) {
            isCorrect = false;
            // this.kpi.forEach((item, index) => {
            //   if (!item.kpi_sub_value) {
            //     isCorrect = false
            //   }
            // })
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "two":
          if (
            !(
              this.partTwoForm.s4_p2_name1 &&
              this.partTwoForm.s4_p2_position1 &&
              this.partTwoForm.s4_p2_work_hrs1
            ) &&
            !(
              this.partTwoForm.s4_p2_name2 &&
              this.partTwoForm.s4_p2_position2 &&
              this.partTwoForm.s4_p2_work_hrs2
            ) &&
            !(
              this.partTwoForm.s4_p2_name3 &&
              this.partTwoForm.s4_p2_position3 &&
              this.partTwoForm.s4_p2_work_hrs3
            )
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "three":
          if (
            !this.partTwoForm.s4_p3_quantity ||
            !this.partTwoForm.s4_p3_quality
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "four":
          if (
            !this.partTwoForm.s4_p4_quantity ||
            !this.partTwoForm.s4_p4_quality
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "five":
          if (
            !this.partTwoForm.s4_p4_revenue ||
            !this.partTwoForm.s4_p4_revenue_desc ||
            !this.partTwoForm.s4_p4_mgm_cost ||
            !this.partTwoForm.s4_p4_mgm_cost_desc ||
            !this.partTwoForm.s4_p4_prod_cap ||
            !this.partTwoForm.s4_p4_prod_cap_desc ||
            !this.partTwoForm.s4_p4_investment ||
            !this.partTwoForm.s4_p4_investment_desc ||
            !this.partTwoForm.s4_p4_social_impact_eval ||
            !this.partTwoForm.s4_p4_social_impact_eval_desc ||
            !this.partTwoForm.s4_p4_sci_tech_impact_eval ||
            !this.partTwoForm.s4_p4_sci_tech_impact_eval_desc
          ) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "six":
          if (!this.partTwoForm.s4_p5_opinion) {
            isCorrect = false;
          }

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
        case "incubation_companies":
          if (!this.incubation_companies || this.incubation_companies.length < 1) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
        case "completed_incubation_companies":
          if (!this.companyList || this.companyList.length < 1) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "annex":
          annexFiles = this.partFiveAttachment.filter((f) => f.doc_type !== 'annex')
            if(!annexFiles || this.annexFiles.length < 1)
              isCorrect = false;

          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    setupBudgetYearMonth() {
      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      let countMonths = 12;
      if (this.isFinal && this.masterData.form_c?.progress_month && this.masterData.form_c?.progress_month > 12) {
        countMonths += this.masterData.form_c.progress_month - 12;
      }
      for (let i = 0; i < countMonths; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit("General/setModal", {
            title: "ระบบไม่พบไฟล์ที่ร้องขอ",
            theme: "warning",
            text: "กรุณาติดต่อเจ้าหน้าที่",
            showCancel: false,
            buttonText: "ตกลง",
          });
        });
    },
    toRequirementFormPreview() {
      let id = this.partOneForm?.requirement_form?.id || null;
      console.log("to preview id :" + id);
      if (id != null)
        this.$router.push({ path: `/requirement-preview/${id}?preview=true` });
    },
  },
};
</script>

<style scoped lang="scss">
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: unset!important;
}
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
</style>
